import { fetchAPI } from '@quickbit/backoffice-core-frontend';
import { SkinningCustomer } from './types';

export interface SkinningCustomerFilters {
  id?: string | null;
  email?: string | null;
  country?: string | null;
  name?: string | null;
  dob?: string | null;
  skin?: string | null;
  is_verified?: string | null;
}

export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc',
}

export interface SkinningCustomerSort {
  field: string;
  order: SortOrder;
}

export interface Pagination {
  page: number;
  size: number;
}

interface PageData {
  total: number;
  page: number;
  size: number;
}

export interface SearchSkinningCustomersResponse {
  customers: SkinningCustomer[];
  pagination: PageData;
}

export const searchSkinningCustomers = (
  filters: SkinningCustomerFilters,
  pagination?: Pagination,
  sort?: SkinningCustomerSort
): Promise<SearchSkinningCustomersResponse> => {
  return fetchAPI<SearchSkinningCustomersResponse>(
    'v1/skinning-customer:search',
    {
      method: 'POST',
      body: {
        filters,
        pagination,
        sort,
      },
    }
  );
};

export const approveSkinningCustomer = (
  id: string,
  approve: boolean,
  reason: string
): Promise<void> => {
  return fetchAPI(`v1/skinning-customer:approve/${id}`, {
    method: 'POST',
    body: {
      approve,
      reason,
    },
  });
};
